<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="640px">
        <div class="row">
            <div class="col-12">
                <el-upload ref="upload"
                           :headers="headers"
                           action="/dispatches/items_import"
                           :show-file-list="false"
                           :auto-upload="false"
                           :multiple="false"
                           :on-error="errorUpload"
                           :on-progress="progressUpload"
                           :on-success="successUpload">
                    <el-button slot="trigger" type="primary">Selecciona un archivo</el-button>
                </el-upload>
            </div>
            <div class="col-12 mt-4">
                <a href="../../formats/import_items_dispatch.xlsx" target="_blank"> Descargar formato ejemplo (xlsx)</a>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                <x-button-submit @click="clickUpload" text="Importar"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XModal from "../../../../components/XModal.vue";
import XInput from "../../../../components/Form/XInput.vue";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit.vue";
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue";

export default {
    name: 'DispatchImport',
    components: {XButtonCancel, XButtonSubmit, XInput, XModal},
    props: ["showDialog"],
    data() {
        return {
            title: "Importar productos",
            headers: headers_token,
            loading: false,
            errors: {},
            form: {},
        };
    },
    methods: {
        handleOpen() {
            this.initForm()
        },
        initForm() {
        },
        clickUpload() {
            this.$refs.upload.submit();
        },
        successUpload(response, file, fileList) {
            console.log('successUpload')
            if (response.success) {
                this.$message.success(response.message)
                this.$emit('success', response.data.items)
                this.clickClose()
            } else {
                this.$message.error(response.message)
            }
            this.loading = false
        },
        errorUpload(response) {
            console.log('errorUpload')
            this.loading = false
        },
        progressUpload() {
            this.loading = true
        },
        clickClose() {
            this.$emit("update:showDialog", false)
        },
    },
};
</script>
